export const getRankColor = (rankName?: string) => {
    const name = rankName
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

    switch (name) {
        case "master":
            return "#FFD700";

        case "esmeralda":
            return "#008000";

        case "constructor":
            return "#0000FF";

        case "diamante":
            return "#C0C0C0";

        case "aprendiz elite":
            return "#800080";

        case "diamante embajador":
            return "#00CED1";

        case "diamante embajador estrella 🌟":
        case "diamante embajador estrella":
            return "#FF1493";

        default:
            return "#8B949E";
    }
};